import { Link } from "react-router-dom";
import { useScrolled } from "@/hooks/useScrolled";
import { cn } from "@/lib/utils";
import { Language, useI18n } from "@/lib/i18n";

export default function Navbar() {
  const scrolled = useScrolled(8);
  const { language, t, path } = useI18n();
  const navLinks = [
    { href: path("clinic"), label: t.nav.clinic },
    { href: path("employees"), label: t.nav.employees },
    { href: path("how"), label: t.nav.how },
    { href: path("contact"), label: t.nav.contact },
  ];
  const languageLabels: Record<Language, string> = { pl: "PL", en: "EN", cz: "CZ" };

  return (
    <header
      className={cn(
        "fixed top-0 inset-x-0 z-50 transition-all duration-300",
        scrolled
          ? "bg-background/85 backdrop-blur-md border-b border-border"
          : "bg-transparent border-b border-transparent"
      )}
    >
      <div className="mx-auto max-w-container px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to={path("home")} className="font-serif text-2xl tracking-tight text-foreground">
          Medessa
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className="whitespace-nowrap text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden xl:flex items-center gap-2" aria-label="Language selection">
            {(["pl", "en", "cz"] as Language[]).map((lang) => (
              <Link
                key={lang}
                to={path("home", lang)}
                className={cn(
                  "text-xs uppercase tracking-[0.14em] transition-colors",
                  language === lang ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                )}
              >
                {languageLabels[lang]}
              </Link>
            ))}
          </div>
          <Link
            to={path("login")}
            className="hidden lg:inline whitespace-nowrap text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t.nav.login}
          </Link>
          <Link
            to={path("contact")}
            className="inline-flex items-center whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            {t.nav.demo}
          </Link>
        </div>
      </div>
    </header>
  );
}
